import { useEffect, useState } from 'react'
import Styles from '../PropertyForm.module.scss'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { type Values as FormValues } from '../PropertyForm'

interface Props {
  values: FormValues
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
  isEdit: boolean
  isValid: boolean
}

const Person = ({ setFieldValue, values, isEdit, isValid }: Props) => {
  const {
    meta: { allow_mentioning_multiple_people, notify_person },
  } = values
  const [allowMentioningMultiplePeople, setAllowMentioningMultiplePeople] = useState(
    allow_mentioning_multiple_people || false,
  )
  const [notifyPerson, setNotifyPerson] = useState(isEdit ? !!notify_person : true)

  const handleToggle = (setting: { [key: string]: boolean }) => {
    if ('allowMentioningMultiplePeople' in setting) {
      setAllowMentioningMultiplePeople(setting.allowMentioningMultiplePeople)
    } else if ('notifyPerson' in setting) {
      setNotifyPerson(setting.notifyPerson)
    }
  }

  useEffect(() => {
    setFieldValue('meta.allow_mentioning_multiple_people', allowMentioningMultiplePeople)
    setFieldValue('meta.notify_person', notifyPerson)
  }, [allowMentioningMultiplePeople, notifyPerson, setFieldValue])

  return (
    <>
      <div className={Styles.sectionSubheader}>
        Mention any person in your workspace (member or guest). You can also choose to notify the selected person when
        they're mentioned.
      </div>
      <div className={Styles.sectionOptions}>
        <div className={Styles.sectionHeader}>Settings</div>
        <div className={Styles.optionTrigger}>
          <ToggleButton
            name="allowMentioningMultiplePeople"
            checked={allowMentioningMultiplePeople}
            handleChange={() => handleToggle({ allowMentioningMultiplePeople: !allowMentioningMultiplePeople })}
            disabled={!isValid}
          ></ToggleButton>
          <div className={Styles.optionHeader}>Allow mentioning multiple people</div>
        </div>
        <div className={Styles.optionTrigger}>
          <ToggleButton
            name="notifyPerson"
            checked={notifyPerson}
            handleChange={() => handleToggle({ notifyPerson: !notifyPerson })}
            disabled={!isValid}
          ></ToggleButton>
          <div className={Styles.optionHeader}>Notify the mentioned person</div>
        </div>
      </div>
    </>
  )
}

export default Person
